import {
  ProductCardViewData,
  ProductCardOption,
  ProductCardSize,
} from '@services/MarppleShop/features/ProductList/type';
import { isDate, isNumber } from '@fxts/core';

export class ProductCardVisibilityManager {
  constructor(
    private readonly size: ProductCardSize,
    private readonly data: ProductCardViewData,
    private readonly option: Omit<ProductCardOption, 'size'>,
  ) {}

  public isLikeButton(): boolean {
    // 옵션
    // const hasLikeButton = !this.option.hide_info;

    // 사이즈에 따른 가시성 컨트롤
    const visibleMap: Record<ProductCardSize, boolean> = {
      xSmall: false,
      small: false,
      medium: true,
      large: true,
    };
    return visibleMap[this.size];
  }

  public isReview(): boolean {
    // 리뷰 있을 때만 노출
    const { review_count, review_score } = this.data;
    const hasReview = review_count && review_count > 0 && review_score && review_score > 0;

    // 사이즈에 따른 가시성 컨트롤
    const sizeMap: Record<ProductCardSize, boolean> = {
      xSmall: false,
      small: true,
      medium: true,
      large: true,
    };

    const reviewHidden = this.option.is_horizontal || this.option.hide_review;

    return Boolean(hasReview && sizeMap[this.size] && !reviewHidden);
  }

  public isBottomTag(): boolean {
    return !this.option.hide_tag && this.data.is_public && !this.option.is_horizontal;
  }

  public isRealtimeTag(): this is { data: { ordered_at: Date } } {
    if (!this.data.ordered_at) {
      return false;
    }
    return isDate(new Date(this.data.ordered_at)) && !this.option.is_horizontal;
  }

  public isWatcherCountTag(): this is { data: { watcher_count: number } } {
    const hasWatcherCount = isNumber(this.data.watcher_count) && this.data.watcher_count > 0;

    const sizeMap: Record<ProductCardSize, boolean> = {
      xSmall: false,
      small: true,
      medium: true,
      large: true,
    };

    return hasWatcherCount && sizeMap[this.size] && !this.option.is_horizontal;
  }
}
